module.exports = __webpack_public_path__ + "img/41.4692895d.jpg";